export const SHARED = {
    DATE_TIME_FORMAT:{
        YYYY_MM_DD:{
            SYNCFUSION:'yyyy-MM-dd',
            MOMENT:'yyyy-MM-DD',  
        },
        YYYY_MM_DD_HH_MM_SS:'yyyy-MM-DD HH:mm a',
    },
    LOG_TYPES:[{id:"", name:'All'},{id:'Info', name:'Info'},{id:'Warn', name:'Warn'},{id:'Error', name:'Error'}],
}